import { createFileRoute } from '@tanstack/react-router';

import { Box } from '@mantine/core';

import { MilestoneWorkflowDesigner } from '@/features/legal-entities/components/MilestoneWorkflowDesigner';
import { useLegalEntityContext } from '@/context/LegalEntityContext';
import { buildHead } from '@/utils/html';

export const Route = createFileRoute('/_authenticated/company/milestones')({
  component: CompanyMilestonesPage,
  head: () => buildHead('milestones'),
});

function CompanyMilestonesPage() {
  const { activeEntity } = useLegalEntityContext();

  if (!activeEntity) return null;

  return (
    <Box px='xl' py='lg'>
      <MilestoneWorkflowDesigner entityId={activeEntity.id} />
    </Box>
  );
}
